// Defaut theme

// HeaderDesktop
export const paddingHeaderDesktop = '5px 70px 5px 70px';
export const backgroundHeader = '#1a62f4';
export const filterLogoHeader = 'none';
export const widthLogoDesktop = '70px';

// HeaderMobile
export const backgroundHeaderMobile = '#1a62f4';
export const widthLogoMobile = '120px';

// Footer
export const backgroundFooterAssinatura = '#1f4f86';
export const textFooterAssinatura = 'white';
export const textParagraphFooterAssinatura = '#bebebe';
export const fontFamilyFooter = 'Roboto, sans-serif';
export const fontWeightH4Footer = '500';
export const fontWeightFooter = '500';

// StepCounter (progress bar)
export const textSpanTimeLine = '#1a62f4';
export const colorTimeLine = '#1a62f4';
export const colorTimeLineBefore = '#4db848';
export const colorTimeLineStatusBefore = 'white';
export const fontFamilyTimeLine = 'Suadrconsulta-Light';
export const fontWeightTimeLine = '900';

// Subscribers list Title
export const colorTitleListSubscribers = '#1a62f4';
export const fontFamilyTitleListSubscribers = 'Suadrconsulta-Light';
export const fontWeightTitleListSubscribers = '600';
export const fontSizeTitleListSubscribers = '18px';

// Subscribers list
export const colorListSubscribers = '#1a62f4';
export const colorListSubscribersFaRegEdit = '#1a62f4';
export const colorListSubscribersFaTrashAlt = '#797977';
export const fontFamilyListSubscribers = 'Suadrconsulta-Light';
export const fontWeightListSubscribers = '600';

// Subscriber Title
export const colorTitleSubscriber = '#1a62f4';
export const fontFamilyTitleSubscriber = 'Suadrconsulta-Light';
export const fontWeightTitleSubscriber = '600';
export const fontFamilyStrongTitleSubscriber = 'Suadrconsulta-Bold';
export const fontWeightStrongTitleSubscriber = '700';
export const fontSizeTitleSubscriber = '20px';

// Subscriber Form
export const colorSubscriber = 'hsl(0, 0%, 20%)';
export const fontFamilySubscriber = 'Suadrconsulta-Light';
export const fontWeightSubscriber = '600';
export const fontWeightLabelSubscriber = '800';
export const colorFilterIconSubscriber =
	'invert(40%) sepia(0%) saturate(8%) hue-rotate(30deg) brightness(100%) contrast(83%)';
export const colorErrorSubscriber = 'red';
export const colorBorderSubscriber = 'hsl(0, 0%, 20%)';
export const colorFormTermsSubscriber = '#333';
export const colorAnchorSubscriber = '#337ab7';
export const backgroundBtnCVVSubscriber = 'black';
export const backgroundSliderSubscriber = '#ccc';
export const backgroundSliderCheckedSubscriber = '#4cae46';

// Payment Title
export const colorTitlePayment = '#1a62f4';
export const fontFamilyTitlePayment = 'Suadrconsulta-Light';
export const fontWeightTitlePayment = '600';

// Payment Nav-tab
export const backgroundNavPayment = '#ddd';
export const backgroundNavAnchorPayment = '#d9d9d9';
export const backgroundNavActivePayment = '#1a62f4';
export const colorNavPayment = 'gray';
export const colorNavActivePayment = 'white';
export const colorNavSvgPayment = 'white';
export const colorNavSvgActivePayment = 'white';
export const fontFamilyNavPayment = 'Suadrconsulta-Light';
export const fontWeightNavPayment = '600';

// Form Button
export const backgroundBtnLoadingBtnDisabledFormButton = '#ddd';
export const colorBtnLoadingBtnDisabledFormButton = 'gray';
export const fontFamilyFormButton = 'Suadrconsulta-Light';
export const fontWeightFormButton = '800';
export const colorBtnAddSubscriberBtnBackFormButton = '#1a62f4';
export const borderBtnAddSubscriberFormButton = '#ddd';
export const backgroundBtnFowardFormButton = '#1a62f4';
export const colorBtnFowardFormButton = 'white';
export const fontWeightBtnFowardBtnBackFormButton = '600';
export const borderBtnBackFormButton = '#7d7d7d';
export const backgroundBtnAddSubscriberFormButton = '#1a62f4'; // Adicionar Titular
export const colorBtnAddSubscriberkFormButton = 'white';
export const colorBtnAdvanceFormButton = 'white';
export const backgroundBtnAdvanceFormButton = '#1a62f4';
export const borderBtnAdvanceFormButton = '#1a62f4';
export const colorBorderBtn = '#1a62f4';
export const colorBorderBtnHover = '#0545c6';
export const colorBackgroundChecked = '#1a62f4';

// Order Resume
export const fontFamilyOrderResume = 'Suadrconsulta-Bold';
export const colorTdOrderResume = '#1a62f4';
export const fontWeightH2H4OrderResume = '500';
export const colorH2H4AnchorIconContainerOrderResume = '#1a62f4';
export const colorIconOrderResume = 'black';
export const colorSmallOrderResume = '#363636';
export const fontWeightSmallOrderResume = '600';
export const colorSpanOrderResume = '#2b2b2b';
export const fontWeightSpanOrderResume = 'bold';
export const colorValueOrderResume = 'hsl(0,0%,20%)';
export const colorInputOrderResume = '#555';
export const backgroundWaitingDisabledButtonOrderResume = '#ddd';
export const colorWaitingDisabledButtonOrderResume = 'gray';
export const backgroundApplyButtonOrderResume = '#1a62f4';
export const colorApplyButtonOrderResume = 'white';
export const colorSvgApplyButtonOrderResume = 'white';
export const colorSvgButtonOrderResume = 'white';
export const colorTdSvgOrderResume = 'black';
export const backgroundOrderResume = '#fff';
export const borderH2OrderResume = '#e4e4e4';
export const borderTopLastChildTdOrderResume = '#ddd';
export const boxShadowOrderResume = 'rgba(0, 0, 0, 0.1)';
export const colorResumeCupomOrderResume = '#23a455';
export const borderOrderResume = '#1a62f4';

// Loading
export const backgroundLoading = '#0a53a6cc';
export const colorFilterImgLoading = 'none';
export const colorTextLoading = 'white';
export const fontFamilyTextLoading = 'Suadrconsulta-Light';
export const fontWeightTextLoading = 'inherit';

// Form Wrapper
export const backgroundFormWrapper = 'white';
export const borderTitularDepende = '#1a62f4';
// Container
export const backgroundContainer = 'none';

// Form Carrinho
export const colorCheckoutItemsH3FormCarrinho = '#0e6fb6';
export const fontFamilyCheckoutItemsH3FormCarrinho = 'Suadrconsulta-Light';
export const fontFamilyPlansH2FormCarrinho = 'Suadrconsulta-Bold';
export const boxShadowInstallmentFormCarrinho = 'rgba(0, 0, 0, 0.3)';
export const backgroundInstallmentFormCarrinho = '#ffffff';
export const boxShadowInstallmentHoverFormCarrinho = 'rgba(166, 206, 57, 1)';
export const colorInstallmentH2FormCarrinho = '#2a6eb3';
export const colorInstallmentTagPercentageFormCarrinho = '#ffffff';
export const fontFamilyInstallmentTagPercentageFormCarrinho =
	'Suadrconsulta-Light';
export const colorTextInstallmentFormCarrinho = '#666';
export const colorInstallmentPriceFormCarrinho = '#00c93f';
export const colorInstallmentTextTotalFormCarrinho = '#00c93f';
export const fontFamilyInstallmentTextTotalFormCarrinho = 'Suadrconsulta-Light';
export const backgroundInstallmentsFirstBoxFormCarrinho = '#2d37aa';
export const backgroundInstallmentsSecondBoxFormCarrinho = '#02b351';
export const backgroundInstallmentsThirdBoxFormCarrinho = '#f3b900';
export const backgroundTextInformationPlanHrFormCarrinho = '#ccc';
export const colorTextInformationPlanTitleFormCarrinho = '#666';
export const fontFamilyTextInformationPlanTitleFormCarrinho =
	'Suadrconsulta-Light';
export const colorInfoBlockH3FormCarrinho = 'rgba(107, 107, 107, 1)';
export const fontFamilyInfoBlockH3FormCarrinho = 'Suadrconsulta-Light';
export const colorInfoBlockParagraphFormCarrinho = '#6b6b6b';
export const fontFamilyInfoBlockParagraphFormCarrinho = 'Suadrconsulta-Light';
export const fontFamilyInfoBlockDetailsFormCarrinho =
	'Arial, Helvetica, sans-serif';
export const colorInfoBlockDetailsFormCarrinho = '#6b6b6b';
export const colorGraceTextFormCarrinho = 'rgba(107, 107, 107, 1)';
export const fontFamilyGraceTextFormCarrinho = 'Suadrconsulta-Bold';
export const backgroundCheckmarkFormCarrinho = '#fff';
export const borderCheckmarkFormCarrinho = '#ffeb00';
export const backgroundContainerCheckboxHoverFormCarrinho = '#e2e2e2';
export const borderCheckmarkAfterFormCarrinho = '#4db848';
export const colorBenefitsAdd2FormCarrinho = 'rgba(107, 107, 107, 1)';
export const fontFamilyBenefitsAdd2FormCarrinho = 'Suadrconsulta-Light';
